import request, { APP_BASE_URL } from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const generate = async (params: {
  batchName: string;
  startTime: string;
  endTime: string;
}) => {
  try {
    const config: ReturnType = {
      url: `redeem-codes/generate`,
      method: "post",
      authorization: true,
      data: params,
      config: {
        successMsg: "Batch generated successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "redeem-codes",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const exportExcel = async (params?: any) => {
  try {
    const config: ReturnType = {
      url: `redeem-codes/export`,
      method: "get",
      authorization: true,
      params,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const checkExportStatus = async (jobId: string) => {
  try {
    const config: ReturnType = {
      url: `redeem-codes/export/status/${jobId}`,
      method: "get",
      authorization: true,
      config: {
        showErr: false,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getDownloadUrl = (jobId: string) => {
  return `${APP_BASE_URL}/redeem-codes/export/download/${jobId}`;
};

const getBatches = async () => {
  try {
    const config: ReturnType = {
      url: "redeem-codes/batches",
      method: "get",
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const bulkDelete = async (params: { ids?: number[]; filters?: any }) => {
  try {
    const config: ReturnType = {
      url: `redeem-codes/bulk-delete`,
      method: "delete",
      authorization: true,
      data: params,
      config: {
        successMsg: "Codes deleted successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  generate,
  list,
  exportExcel,
  checkExportStatus,
  getDownloadUrl,
  bulkDelete,
  getBatches,
};
